import * as React from "react"
export const ToolbarMove = (props:any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g>
      <path
        fill="#6C757D"
        d="M19.46 8.547c-.195-.219-.386-.427-.517-.558l-1.87-1.903a.833.833 0 0 0-1.189 1.167l1.876 1.908.007.009h-6.934V2.29l1.861 1.829a.833.833 0 0 0 1.167-1.188l-1.9-1.867a14.68 14.68 0 0 0-.56-.52 2.146 2.146 0 0 0-1.378-.536A.23.23 0 0 0 10 .003h-.01a2.153 2.153 0 0 0-1.446.54c-.219.193-.427.384-.558.515L6.083 2.931A.833.833 0 1 0 7.25 4.119l1.908-1.876.009-.007V9.17H2.233l.013-.013 1.87-1.904a.833.833 0 1 0-1.188-1.167L1.062 7.984c-.136.136-.327.344-.52.562A2.15 2.15 0 0 0 0 9.994v.009c0 .008.004.016.005.024.01.509.2.997.537 1.378.194.218.384.426.515.558l1.87 1.903A.833.833 0 0 0 4.117 12.7l-1.83-1.864h6.88v6.934l-.012-.012-1.904-1.87a.834.834 0 1 0-1.167 1.188l1.899 1.865c.136.136.344.326.562.52a2.156 2.156 0 0 0 2.859 0c.218-.194.425-.383.557-.515l1.903-1.87a.834.834 0 1 0-1.166-1.188l-1.864 1.828v-6.88h6.88l-1.833 1.861a.833.833 0 1 0 1.188 1.167l1.866-1.9c.136-.135.326-.344.52-.562a2.157 2.157 0 0 0 .005-2.855Z"
      />
    </g>
  </svg>
)

